<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="egyuttcascoVisible()" :attributes="egyuttcasco" />

            <BnFormField v-if="homeOfficeVisible()" :attributes="homeoffice" />

            <BnFormField :attributes="this['13_csoport_2019']" />

            <BnFormField :attributes="generali_cegcsopkedv_azon" />

            <BnFormField v-if="myGenertelVisible()" :attributes="mygenertel" />

            <BnFormField v-if="kmallaIsmertVisible()" :attributes="kmallas"/>

            <BnFormField v-if="muszakiVizsgaKedvezmenyVisible()" :attributes="muszakiVizsgaKedvezmeny" />

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import TariffAnnouncementUtils from '../../../../../../../utils/TariffAnnouncementUtils';
import { CSEKK } from '../../../../../../../modules/FizetesiMod';
import DateFormat from '../../../../../../../utils/DateFormat';

export default {
    name: 'KedvezmenyekB13',
    components: {
        KedvezmenyekBase,
        BnFormField,
    },
    mixins: [Kedvezmeny],

    methods: {
        kmallaIsmertVisible() {
            return TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2023, 'kgfb', this.$store)
                && this.isSZGK();
        },
      muszakiVizsgaKedvezmenyVisible() {
        const kockKezdStr = DateFormat.plainToDashed(this.$store.getters.tarifaData.ajanl_kock_kezd);
        return this.isSZGK() && kockKezdStr >= '2026-02-11';
      },
        myGenertelVisible() {
            return this.$store.getters.tarifaData.egfb_regisztracio
                && this.$store.getters.tarifaData.allianzemail
                && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2022, 'kgfb', this.$store)
                && this.$store.getters.tarifaData.ajanl_fizmod_type !== CSEKK;
        },
        egyuttcascoVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        partnerVisible() {
            return this.isTermeszetesSzemely();
        },
    },
    computed: {
        // TODO többi attribute-ot is computedba rakni
        egyuttcasco() {
            return {
                label: 'CASCO együttkötési kedvezmény',
                type: 'checkbox',
                visible: true,
                editable: !this.disabled && !this.egyuttkotve,
                rules: [],
                path: 'kedvezmenyekbiztosito.13.egyuttcasco',
                mezo: 'genertel_egyuttcasco',
                change: this.shouldRecalc,
                help: true,
            };
        },
    },
    data() {
        return {
            homeoffice: {
                label: 'Home office kedvezmény',
                type: 'checkbox',
                visible: true,
                editable: !this.disabled,
                rules: [],
                path: 'kedvezmenyekbiztosito.13.homeoffice',
                mezo: 'genertel_homeoffice',
                change: this.shouldRecalc,
                help: true,
            },
            '13_csoport_2019': {
                label: 'Generali csoport kedvezmény',
                type: 'checkbox',
                visible: true,
                editable: !this.disabled,
                rules: [],
                path: 'kedvezmenyekbiztosito.13.csoport',
                mezo: 'genertel_13_csoport_2019',
                change: this.shouldRecalc,
                help: true,
            },
            generali_cegcsopkedv_azon: {
                label: 'Generali cégcsoport igazoló szerződés szám',
                type: 'text',
                visible: true,
                editable: !this.disabled,
                rules: [],
                path: 'kedvezmenyekalaptabla.13.generali_cegcsopkedv_azon',
                mezo: 'genertel_generali_cegcsopkedv_azon',
                change: this.shouldRecalc,
                help: false,
            },
            partner: {
                label: 'Partner kedvezmény',
                type: 'checkbox',
                visible: true,
                editable: !this.disabled,
                rules: [],
                path: 'kedvezmenyekbiztosito.13.partner',
                mezo: 'genertel_partner',
                change: this.shouldRecalc,
                help: true,
            },
            mygenertel: {
                label: 'MyGenertel',
                type: 'checkbox',
                visible: true,
                editable: !this.disabled,
                rules: [],
                path: 'kedvezmenyekbiztosito.13.mygenertel',
                mezo: 'genertel_mygenertel',
                change: this.shouldRecalc,
                help: true,
            },
            kmallas: {
                type: 'checkbox',
                label: 'Km óra állása ismert',
                visible: true,
                editable: !this.disabled,
                path: 'kedvezmenyekbiztosito.13.kmallas',
                mezo: 'genertel_kmallas',
                help: true,
                rules: [],
                change: this.shouldRecalc,
            },
            muszakiVizsgaKedvezmeny: {
              type: 'checkbox',
              label: 'Utolsó műszaki vizsga időpontja 180 napon belüli',
              visible: true,
              editable: !this.disabled,
              path: 'kedvezmenyekbiztosito.13.muszakiVizsgaKedvezmeny',
              mezo: 'genertel_muszakiVizsgaKedvezmeny',
              help: true,
              rules: [],
              change: this.shouldRecalc,
            },
        };
    },
};
</script>
